// extracted by mini-css-extract-plugin
export default {"edit-dropdown-container":"ActivityManagement_edit-dropdown-container__ZI5Wn","block-tiny-line":"ActivityManagement_block-tiny-line__Kw+FR"};